import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

  export const getPickupAllocated = createAsyncThunk('data/getPickupAllocated',
    async(data)=>{
      const res = await axiosInstance.get(`/api/v1/getPickupDetails?page=${data.page}&limit=${data.limit}&OfficeId=${data.OfficeId}&isAllocated=${data.isAllocated}&search=${data.search}`);
        return res.data
    }
  )
// pickupThunks.js


// ---------------------  Pickup and package Details ========================== 

//get Pickup Details
//  export const getPickupDetails = createAsyncThunk('data/getPickupDetails',
//     async(data)=>{
//       const res = await axiosInstance.get(`/api/v1/getPickupDetails?page=${data.page}&limit=${data.limit}&search=${data.search}&isAllocated=${data.isAllocated}&OfficeId=${data.OfficeId}&Status=${data.Status}`);
//       return res.data
//     }
//   )
export const getPickupDetails = createAsyncThunk('data/getPickupDetails',
  async(data) => {
    const res = await axiosInstance.get(`/api/v1/getPickupDetails`, {
      params: {
        page: data.page,
        limit: data.limit,
        search: data.search,
        isAllocated: data.isAllocated,
        OfficeId: data.OfficeId,
        Status: data.Status,
        createdFrom: data.createdFrom,
        createdTo: data.createdTo,
        CustomerName: data.CustomerName,
        Destination: data.Destination,
        Origin: data.Origin,
        isExport: data.isExport || "false",
        reverseSort: data.reverse || false,
      }
    });
    return res.data;
  }
);


//Create Pickup Details
export const createPickupDetails = createAsyncThunk('data/createPickup',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/createPickupDetails', data);
      return res.data
  }
)

//Update Pickup Details
export const updatePickupDetails = createAsyncThunk('data/updatePickup',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/updatePickupDetails', data);
      return res.data
  }
)

//Delete Pickup Details
export const deletePickupDetails = createAsyncThunk('data/deletePickupDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/deletePickupDetails/${data}`);
      return res.data
    }
)

//=============Create Package Details  =============================
export const createPackageDetails = createAsyncThunk('data/createPackage',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/createPackageDetails', data);
      return res.data
  }
)

//Delete Pickup Details
export const deletePackageDetails = createAsyncThunk('data/deletePackageDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/deletePackageDetails/${data}`);
      return res.data
    }
)

// getDeliveryBoyList
export const getDeliveryBoyList = createAsyncThunk(
  'data/getDeliveryBoyList',
  async (data) => {
    const res = await axiosInstance.get(
      `/api/v1/office/deliveryboys/${data.OfficeId}`, // OfficeId in path
      {
        params: {
          page: data.page,
          limit: data.limit,
        },
      }
    );
    return res.data;
  }
);

  // createAllocatedDeliveryboy
  export const createAllocatedDeliveryboy = createAsyncThunk('data/createAllocatedDeliveryboy', 
    async(data)=>{
        const res = await axiosInstance.post('/api/v1/CreateallocationbyDeliveryboy', data);
        return res.data
    }
  )
  export const getDocket = createAsyncThunk('data/getDocket',
    async(data)=>{
      const res = await axiosInstance.get(`/api/v1/docket/getDocketDetails?page=${data.page}&limit=${data.limit}&isManifest=${data.isManifest || "false"}&search=${data.search}`);
        return res.data
    }
  )